<iframe [src]="link" frameborder="0" width="100%"></iframe>
<div *ngIf="loading;" style="padding-top: 0%;">
    <div style="text-align: center;">
        <i class="pi pi-spin pi-spinner" id="spinIcon1"></i>
    </div>
</div>